module.exports = {"pt-BR":{"alert":{"contacts":{"whatsapp":"Whatsapp:","whatsappLink":"+55 800 591 1509","email":"Email:","emailLink":"contato@alpop.com.br"}}}}